import React, {Component} from 'react';

import {
    Row,
} from 'reactstrap';

import BioForm from "./forms/BioForm";

class BioFrame extends Component {
    render() {
        return (

            <div>
                <Row>
                    <h3>Tell us a little bit about yourself</h3>
                </Row>
                <hr/>
                <p>Landlords love it when tenants tell them some additional information (so
                    we're making you fill it out). Tell the landlord something about yourself
                    (and don't make it sound like your Tinder profile); see our example.
                </p>

                <BioForm/>
            </div>
        );
    }
}

export default BioFrame;



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/BioFrame.js